var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgSms = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M22.16 64.187c-4.786 0-8.66-3.885-8.66-8.684V26.684c0-4.799 3.874-8.684 8.66-8.684h51.212c4.785 0 8.66 3.885 8.66 8.684v28.819c0 4.8-3.875 8.684-8.66 8.684h-5.505a1.05 1.05 0 0 0-1.056 1.059v11.33c0 .938-1.139 1.407-1.799.746L52.227 64.5a1.073 1.073 0 0 0-.743-.313h-1.8"
  }), React.createElement("path", {
    fill: borderColor,
    fillRule: "evenodd",
    d: "M22.16 18.75c-4.37 0-7.91 3.547-7.91 7.934v28.819c0 4.387 3.54 7.934 7.91 7.934a.75.75 0 0 1 0 1.5c-5.202 0-9.41-4.223-9.41-9.434V26.684c0-5.211 4.208-9.434 9.41-9.434h51.212c5.202 0 9.41 4.223 9.41 9.434v28.819c0 5.211-4.208 9.434-9.41 9.434h-5.505a.301.301 0 0 0-.306.309v11.33c0 1.607-1.948 2.41-3.08 1.275L51.696 65.03a.324.324 0 0 0-.212-.092h-1.8a.75.75 0 0 1 0-1.5h1.8c.484 0 .948.206 1.274.533l12.785 12.822a.305.305 0 0 0 .518-.216v-11.33a1.8 1.8 0 0 1 1.806-1.809h5.505c4.37 0 7.91-3.547 7.91-7.934V26.684c0-4.387-3.54-7.934-7.91-7.934H22.159Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M24.563 46.219a.75.75 0 0 1 .75-.75h28.5a.75.75 0 1 1 0 1.5h-28.5a.75.75 0 0 1-.75-.75ZM41.063 37.219a.75.75 0 0 1 .75-.75h28.5a.75.75 0 1 1 0 1.5h-28.5a.75.75 0 0 1-.75-.75ZM60.563 29.719a.75.75 0 0 1 .75-.75h9a.75.75 0 1 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM24.563 29.719a.75.75 0 0 1 .75-.75h28.5a.75.75 0 1 1 0 1.5h-28.5a.75.75 0 0 1-.75-.75ZM24.563 37.219a.75.75 0 0 1 .75-.75h9a.75.75 0 1 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM60.563 46.219a.75.75 0 0 1 .75-.75h9a.75.75 0 1 1 0 1.5h-9a.75.75 0 0 1-.75-.75Z"
  }), React.createElement("path", {
    fill: color,
    d: "M45.072 72.135c1.929 0 3.49-1.68 3.49-3.756V55.914c0-2.075-1.561-3.756-3.49-3.756H24.428c-1.929 0-3.49 1.68-3.49 3.756V68.38c0 2.076 1.561 3.756 3.49 3.756h2.22c.236 0 .425.203.425.458v4.9c0 .407.459.61.725.323l5.154-5.545a.419.419 0 0 1 .3-.136h.724"
  }), React.createElement("path", {
    fill: borderColor,
    fillRule: "evenodd",
    d: "M45.072 52.908c1.464 0 2.74 1.292 2.74 3.006V68.38c0 1.715-1.276 3.006-2.74 3.006h-11.82c-.338 0-.643.153-.85.375l-4.58 4.928v-4.095c0-.616-.473-1.208-1.175-1.208h-2.219c-1.464 0-2.74-1.291-2.74-3.006V55.914c0-1.714 1.276-3.006 2.74-3.006h20.644Zm4.24 3.006c0-2.437-1.846-4.506-4.24-4.506H24.428c-2.394 0-4.24 2.07-4.24 4.506V68.38c0 2.438 1.846 4.506 4.24 4.506h1.895v4.609c0 .507.296.923.708 1.106.42.186.95.122 1.316-.273l5.057-5.442h11.668c2.394 0 4.24-2.069 4.24-4.506V55.914Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M31.25 61.61a.371.371 0 0 0-.527 0 .376.376 0 0 0 0 .53l2.484 2.496a.371.371 0 0 0 .527 0l5.463-5.492a.376.376 0 0 0 0-.53.371.371 0 0 0-.527 0l-5.2 5.228-2.22-2.232Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M38.139 58.085a1.12 1.12 0 0 1 1.59 0 1.126 1.126 0 0 1 0 1.588l-5.464 5.492a1.121 1.121 0 0 1-1.59 0l-2.483-2.497a1.126 1.126 0 0 1 0-1.587 1.121 1.121 0 0 1 1.59 0l1.688 1.697 4.669-4.693Z",
    clipRule: "evenodd"
  }));
};
export default SvgSms;